export default __webpack_public_path__ + "static/media/bdswissSCDemo_downloadMT4.9ad3e8f8.png";